import {
  getSalaryStructures as getSalaryStructuresService,
  createSalaryStructure as createSalaryStructureService,
  updateSalaryStructure as updateSalaryStructureService,
  deleteSalaryStructure as deleteSalaryStructureService,
} from "services/company/payrollManagement/salaryStructure/salaryStructureService";
import {
  getSalaryStructuresStart,
  getSalaryStructuresSuccess,
  getSalaryStructuresFailure,
  createSalaryStructureStart,
  createSalaryStructureSuccess,
  createSalaryStructureFailure,
  updateSalaryStructureStart,
  updateSalaryStructureSuccess,
  updateSalaryStructureFailure,
  deleteSalaryStructureStart,
  deleteSalaryStructureSuccess,
  deleteSalaryStructureFailure,
} from "./salaryStructureSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all salary structures
export const fetchSalaryStructures = () => async (dispatch) => {
  try {
    dispatch(getSalaryStructuresStart());
    const response = await getSalaryStructuresService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getSalaryStructuresSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to fetch salary structures";
      dispatch(getSalaryStructuresFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch salary structures error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch salary structures";
    dispatch(getSalaryStructuresFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new salary structure
export const createNewSalaryStructure = (salaryData) => async (dispatch) => {
  try {
    dispatch(createSalaryStructureStart());
    const response = await createSalaryStructureService(salaryData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createSalaryStructureSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Salary structure created successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to create salary structure";
      dispatch(createSalaryStructureFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create salary structure error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create salary structure";
    dispatch(createSalaryStructureFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update a salary structure
export const updateExistingSalaryStructure =
  (salaryStructureId, salaryData) => async (dispatch) => {
    try {
      dispatch(updateSalaryStructureStart());
      const response = await updateSalaryStructureService(
        salaryStructureId,
        salaryData,
      );

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateSalaryStructureSuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Salary structure updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update salary structure";
        dispatch(updateSalaryStructureFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update salary structure error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update salary structure";
      dispatch(updateSalaryStructureFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Delete a salary structure
export const deleteExistingSalaryStructure =
  (salaryStructureId) => async (dispatch) => {
    try {
      dispatch(deleteSalaryStructureStart());
      const response = await deleteSalaryStructureService(salaryStructureId);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(deleteSalaryStructureSuccess(salaryStructureId));
        showSuccessToast(
          response?.meta?.message ||
            "Salary structure inactivated successfully!",
        );
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to delete salary structure";
        dispatch(deleteSalaryStructureFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Delete salary structure error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to delete salary structure";
      dispatch(deleteSalaryStructureFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
